import React, { useEffect, useRef } from "react";
import { decode } from "@googlemaps/polyline-codec";

const MapComponent = ({ encodedShapes }) => {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const polylineRefs = useRef([]);

    useEffect(() => {
        const shapes = encodedShapes?.length > 0 ? encodedShapes : ["svzmE`j}xOb@gD~AmFn@wB"];
        const paths = shapes.map(shape =>
            decode(shape, 6).map(([lat, lng]) => ({ lat, lng }))
        );

        if (!window.google || !mapRef.current || paths.length === 0 || paths[0].length === 0) return;

        // Initialize map once
        if (!mapInstance.current) {
            mapInstance.current = new window.google.maps.Map(mapRef.current, {
                zoom: 6,
                center: paths[0][0],
                mapTypeId: "roadmap",
            });
        }

        // Clear existing polylines
        polylineRefs.current.forEach(poly => poly.setMap(null));
        polylineRefs.current = [];

        // Draw each path
        const bounds = new window.google.maps.LatLngBounds();
        paths.forEach((path, index) => {
            const polyline = new window.google.maps.Polyline({
                path,
                geodesic: true,
                strokeColor: "#007BFF",
                strokeOpacity: 1.0,
                strokeWeight: 4,
            });
            polyline.setMap(mapInstance.current);
            polylineRefs.current.push(polyline);
            path.forEach(point => bounds.extend(point));
        });

        // Add a marker for each leg's starting point (except first which already has label A)
        paths.forEach((path, index) => {
          if (index === 0) return; // skip, already handled
          new window.google.maps.Marker({
            position: path[0],
            map: mapInstance.current,
            label: `${index + 1}`,
          });
        });

        // Fit map to bounds
        mapInstance.current.fitBounds(bounds);

        // Start marker with truck icon and label
        new window.google.maps.Marker({
            position: paths[0][0],
            map: mapInstance.current,
            icon: {
                url: "https://maps.google.com/mapfiles/kml/shapes/truck.png",
                scaledSize: new window.google.maps.Size(32, 32),
            },
            title: "Start",
        });

        // End marker with flag icon and label
        const lastPath = paths[paths.length - 1];
        new window.google.maps.Marker({
            position: lastPath[lastPath.length - 1],
            map: mapInstance.current,
            icon: {
                url: "https://maps.google.com/mapfiles/kml/shapes/flag.png",
                scaledSize: new window.google.maps.Size(32, 32),
            },
            title: "Destination",
        });
    }, [encodedShapes]);

    return (
        <div
        	id="google-map"
            ref={mapRef}
        />
    );
};

export default MapComponent;